import styled from 'styled-components'

const mainColor = props => props.theme.colors.main || 'red'

const SelectableText = styled.span`
    border-radius: 1px;
    border-color: ${mainColor};
    cursor: pointer;
    color: ${mainColor};
`

export default SelectableText
